module.exports = __webpack_public_path__ + "static/media/track-train-in-the-distance.73b9c06e.png";